document.addEventListener("turbolinks:load", function () {
    const mapContainer = document.getElementById("mapReTSPy");
    const yearSelect = document.getElementById("year-select");
    const monthSelect = document.getElementById("month-select");

    if (mapContainer && !mapContainer._leaflet_map) {
        const map = L.map(mapContainer).setView([-23.4425, -58.4438], 7); // Centrando en Paraguay
        mapContainer._leaflet_map = map; // Marca el contenedor como inicializado
        // Variables globales para los gráficos
        let chartByTypeInstance = null;
        let chartByMonthInstance = null;
        let chartByDepartmentInstance = null;
        let chartByTypeAndMonthInstance = null;

        const colors = {
            GRA: "green",
            RAF: "blue",
            TOR: "red",
            "EMB": "purple",
            "TRB": "gray",
            "RAF Y GRA": "yellow",
        };
        const typeNames = {
            GRA: "Granizos",
            RAF: "Ráfagas",
            TOR: "Tornados",
            "EMB": "Embudos",
            "TRB": "Trombas",
            "RAF Y GRA": "Ráfagas y Granizos",
        };
        // Array de nombres de meses en español
        const monthNames = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);
        const markerGroup = L.layerGroup().addTo(map);

        function renderMarkers(data) {
            markerGroup.clearLayers();
            data.forEach((retspy) => {
                const marker = L.marker([retspy.latitude, retspy.longitude], {
                    icon: L.divIcon({
                        className: `marker-icon marker-${colors[retspy.r_type]}`,
                        iconSize: [10, 10],
                    }),
                }).addTo(markerGroup);

                marker.bindPopup(`
                    <strong>${retspy.description}</strong><br>
                    <a href="/retspies/${retspy.id}" class="btn btn-link btn-sm">Ver más</a>
                `);
            });
        }

        function updateStatistics(stats, year, month) {
            // Actualizar título
            const title = document.getElementById("retspy-title");
            const period = `${month ? monthNames[month-1] + "/" : ""}${year || "Todos los registros"}`;
            title.textContent = `PERIODO RETSPY: ${period}`;
            document.getElementById("chartByTypeTitle").textContent = `Reportes por Tipo de Evento [${period}]`;

            // Destruir gráficos existentes si ya están creados
            if (chartByTypeInstance) chartByTypeInstance.destroy();
            if (chartByMonthInstance) chartByMonthInstance.destroy();
            if (chartByDepartmentInstance) chartByDepartmentInstance.destroy();
            if (chartByTypeAndMonthInstance) chartByTypeAndMonthInstance.destroy();

            const resultTypes = Object.keys(stats.by_type);
            if (resultTypes.length === 1) {
                document.getElementById("chartByMonthTitle").textContent = `Reportes de ${typeNames[resultTypes[0]]} por Mes [${period}]`;
                document.getElementById("chartByDepartmentTitle").textContent = `Reportes de ${typeNames[resultTypes[0]]} por Departamento [${period}]`;
                document.getElementById("chartByTypeAndMonthTitle").textContent = `Reportes de ${typeNames[resultTypes[0]]} por Mes y Tipo [${period}]`;
            } else {
                document.getElementById("chartByMonthTitle").textContent = `Reportes de Tiempo Severo por Mes [${period}]`;
                document.getElementById("chartByDepartmentTitle").textContent = `Reportes de Tiempo Severo por Departamento [${period}]`;
                document.getElementById("chartByTypeAndMonthTitle").textContent = `Reportes de Tiempo Severo por Mes y Tipo [${period}]`;
            }

            // Mapear los colores para los tipos
            const typeColors = resultTypes.map(type => {
                // Devuelve el color del objeto `colors` correspondiente al tipo
                return colors[type] || "rgba(200, 200, 200, 0.6)"; // Color por defecto si el tipo no existe
            });
            const months = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12

            // Crear el gráfico por tipo
            chartByTypeInstance = new Chart(document.getElementById("chartByType"), {
                type: "bar",
                data: {
                    labels: resultTypes, // Los tipos como etiquetas
                    datasets: [{
                        label: "Cantidad",
                        data: Object.values(stats.by_type), // Cantidades por tipo
                        backgroundColor: typeColors // Colores personalizados
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: true },
                        tooltip: { callbacks: {} }
                    }
                }
            });

            // Crear el gráfico por mes
            chartByMonthInstance = new Chart(document.getElementById("chartByMonth"), {
                type: "line",
                data: {
                    // Mapear los números de los meses a sus nombres
                    labels: Object.keys(stats.by_month).map(month => monthNames[parseInt(month, 10) - 1]),
                    datasets: [{
                        label: "Cantidad",
                        data: Object.values(stats.by_month),
                        borderColor: "rgba(75, 192, 192, 1)",
                        fill: false
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: true },
                        tooltip: { callbacks: {} }
                    }
                }
            });

            chartByDepartmentInstance = new Chart(document.getElementById("chartByDepartment"), {
                type: "bar", // Cambiar a gráfico de barras
                data: {
                    labels: Object.keys(stats.by_department), // Etiquetas (departamentos)
                    datasets: [{
                        data: Object.values(stats.by_department), // Valores (cantidades)
                        backgroundColor: "#FF9F40", // Color de las barras
                    }]
                },
                options: {
                    indexAxis: 'y', // Configuración para barras horizontales
                    scales: {
                        x: {
                            title: {
                                display: true,
                                text: 'Cantidad', // Etiqueta para el eje X
                            },
                            beginAtZero: true // Asegura que el eje X comienza en 0
                        },
                        y: {
                            title: {
                                display: true,
                                text: 'Departamentos', // Etiqueta para el eje Y
                            },
                            ticks: {
                                autoSkip: false, // Asegura que no se omitan etiquetas
                                maxRotation: 0, // Evita la rotación del texto
                                minRotation: 0 // Mantiene el texto horizontal
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            display: false // Oculta la leyenda ya que no es necesaria en este caso
                        }
                    }
                }
            });

            chartByTypeAndMonthInstance = new Chart(document.getElementById("chartByTypeAndMonth"), {
                type: "bar",
                data: {
                    labels: monthNames, // Etiquetas de los meses
                    datasets: resultTypes.map(type => ({
                        label: typeNames[type], // Nombres amigables de los tipos
                        backgroundColor: colors[type], // Colores asignados a cada tipo
                        data: months.map(month => stats.by_month_and_type[month]?.[type] || 0) // Datos por mes y tipo
                    }))
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: { callbacks: {} },
                        legend: { display: true } // Muestra la leyenda para identificar cada tipo
                    },
                    scales: {
                        x: {
                            stacked: false, // Sin apilar para barras agrupadas
                            title: { display: true, text: "Mes" }
                        },
                        y: {
                            stacked: false, // Sin apilar en el eje Y
                            beginAtZero: true,
                            title: { display: true, text: "Cantidad" }
                        }
                    },
                    barThickness: 20, // Ajusta el grosor de las barras si es necesario
                    categoryPercentage: 0.8, // Controla la separación entre grupos de barras
                    barPercentage: 0.9 // Controla el tamaño de las barras dentro del grupo
                }
            });
        }

        function fetchData(rType, year, month) {
            let params = [];
            if (year) params.push(`year=${year}`);
            if (month) params.push(`month=${month}`);
            if (rType && rType !== "all") params.push(`r_type=${encodeURIComponent(rType)}`);
            const paramString = params.length > 0 ? `?${params.join("&")}` : "";

            fetch(`/retspies/map_data${paramString}`)
                .then((response) => response.json())
                .then((data) => {
                    renderMarkers(data.map_data);
                    updateStatistics(data.stats, year, month);
                })
                .catch((error) => console.error("Error al cargar los datos:", error));
        }

        document.querySelectorAll('.filter-btn').forEach((button) => {
            button.addEventListener('click', function () {
                document.querySelectorAll('.filter-btn').forEach((btn) => btn.classList.remove('active'));
                this.classList.add('active');

                const rType = this.dataset.type || 'all';
                const year = yearSelect.value || null;
                const month = monthSelect.value || null;

                fetchData(rType, year, month);
            });
        });

        yearSelect.addEventListener("change", () => {
            const rType = document.querySelector('.filter-btn.active')?.dataset.type || 'all';
            const year = yearSelect.value || null;
            const month = monthSelect.value || null;

            fetchData(rType, year, month);
        });

        monthSelect.addEventListener("change", () => {
            const rType = document.querySelector('.filter-btn.active')?.dataset.type || 'all';
            const year = yearSelect.value || null;
            const month = monthSelect.value || null;

            fetchData(rType, year, month);
        });

        // Inicialización inicial
        fetchData();
    }
});

document.addEventListener("turbolinks:before-cache", function () {
    const mapContainer = document.getElementById("mapReTSPy");
    if (mapContainer && mapContainer._leaflet_map) {
        mapContainer._leaflet_map.remove(); // Destruye el mapa
        delete mapContainer._leaflet_map;  // Limpia la referencia
    }
});